import { render, staticRenderFns } from "./Warranty-Manage.vue?vue&type=template&id=72b95c48&scoped=true&"
import script from "./Warranty-Manage.vue?vue&type=script&lang=js&"
export * from "./Warranty-Manage.vue?vue&type=script&lang=js&"
import style0 from "./Warranty-Manage.vue?vue&type=style&index=0&id=72b95c48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b95c48",
  null
  
)

export default component.exports